import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import PythonService from "src/api/PythonService";


export default function RangeProduct(props) {
  const [KeyValue, setKeyValue] = useState({});
  const [marks, setmarks] = useState([]);
  const [value, setValue] = useState(0);
  const [DefaultVvalue, setDefaultVvalue] = useState(0);
  
  function ProductHierarchy(){
        var data=props.form;
        var loc= data['product-level']['data'];   
        var default_value= data['product-level']['default-value'];   
        var count= Object.keys(loc).length -1;

          let valueCount=0;
         var i=0;
         var obj={};
         var marksV = [];
        for ( const [key,value] of Object.entries(loc) ) {
          obj[valueCount]=key;
          marksV.push(
               {
                value: valueCount,
                label: value,
                name:key
               }
          );
          const position = ((i + 1) / count) * 100;
          valueCount = position;         
           i++;
  
        }
       var kk= getKeyByValue(obj,default_value);
       props.onChange(default_value);
        console.log(kk);
        setmarks(marksV)
        setKeyValue(obj);
        setValue(kk);
        props.ProdSlider(obj);
  }

  useEffect(() => {
    ProductHierarchy();
  },[]);

  function valuetext(value) {  
    return value;
  }  
  function valueLabelFormat(value) {
    return marks.findIndex((mark) => mark.value === value) + 1;
  }
  function handleChange(event, newValue){
    
    setValue(newValue)
    props.ProdSlider(KeyValue);
    props.onChange(KeyValue[event.target.value]);
  }


  function getKeyByValue(KeyValue, value) {
    if (value === '0') {
      return '0'; // Return null if value is not found
    }
    
    for (const [key, ovalue] of Object.entries(KeyValue)) {
      if (ovalue === value) {
        return key;
      }
    }
  
    return '0'; // Return null if value is not found
  }


const default_range = value;

if(default_range==0){
  return (
    <Box  sx={{ width: '90%' }}>
      <Slider
        // aria-label="Restricted values"
        defaultValue={0}
        value={0}
        valueLabelFormat={valueLabelFormat}
        getAriaValueText={valuetext}
        step={null}
        onChange={handleChange}
        // valueLabelDisplay="on"
        marks={marks}
      />
    </Box>
  );
}else{
  return (
    <Box  sx={{ width: '90%' }}>
      <Slider
        // aria-label="Restricted values"
        defaultValue={0}
        value={value==0?default_range:value}
        valueLabelFormat={valueLabelFormat}
        getAriaValueText={valuetext}
        step={null}
        onChange={handleChange}
        // valueLabelDisplay="on"
        marks={marks}
      />
    </Box>
  );
}
}

